var funcTimer = 0;
function useVinBtn() {
    setTimeout(() => {
        //console.log(`Vin function runs: ${funcTimer}`)
        const vinBtn = document.querySelector(".use-vin-btn");
        const vinModal = document.querySelector("[id$=VINDetails].sk-uigroup-item");
        const vinNext = document.querySelector("[id$=VINDetails] button[title='NEXT']");
    
        if(vinBtn && !vinBtn.getAttribute("modal-func")) {
            vinBtn.setAttribute("modal-func", "true");

            vinBtn.addEventListener("click", () => {
                vinModal.classList.add("modal-open");
            })
            vinNext.addEventListener('click', () => {setTimeout(() => {checkVinInput()},500)});
            if(!vinModal.querySelector("span.close-modal")) {
                vinModal.querySelector(".sk-column-list").insertAdjacentHTML("afterbegin",`<span class="close-modal"></span>`);
                document.querySelector(".close-modal").addEventListener("click", () => {
                    closeVinModal();
                })  
            }
            useVinBtn(); //check the function succeded
        } else if(funcTimer < 5) {
            funcTimer++;
            useVinBtn();
        } else {
            funcTimer = 0;
            return;
        }
    }, 250)
}

function checkVinInput() {
    const vinInput = document.querySelector("[id$=VINNumber]");
    const incorrectVin = document.querySelector("[id$=VINErrorMessage]");
    const vinNext = document.querySelector("[id$=VINDetails] button[title='NEXT']");

    if(vinNext.classList.contains("sk-button--loading")) {
        setTimeout(() => {
            checkVinInput();
        }, 250)
    } else if (incorrectVin) {
        vinInput.classList.add("sk-attr--error");
        return;
    } else {
        if(vinInput.classList.contains("sk-attr--error")) {
            return;
        } else if (vinInput.querySelector("input[id$=VINNumber]").value == "") {
            return;
        } else {
            setTimeout(() => {closeVinModal()}, 2000);
        }   
    }
}

function closeVinModal() {
    const vinModal = document.querySelector("[id$=VINDetails].sk-uigroup-item")
    const vinNumberAttribute = document.querySelector("#Motor-capturedData-carInformation-VINNumber")
    if(vinModal && vinNumberAttribute) {
        vinNumberAttribute.focus()
        vinNumberAttribute.value = "";
        vinNumberAttribute.blur();
        setTimeout(() => {
            vinModal.classList.remove("modal-open");
        }, 500);
    }
}

export { useVinBtn };